package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val ProfileDescriptionStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }
    Breakpoint.SM {
        Modifier.width(500.px)
    }
    Breakpoint.MD {
        Modifier.width(805.px)
    }
}